var _path, _path2, _g, _g2, _path3, _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 98,
    viewBox: "0 0 192 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_98)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188 0H4C1.79086 0 0 1.79086 0 4V94C0 96.2091 1.79086 98 4 98H188C190.209 98 192 96.2091 192 94V4C192 1.79086 190.209 0 188 0Z",
    fill: "#B8C4E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_98",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 192,
    height: 98
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188 0H4C1.79086 0 0 1.79086 0 4V94C0 96.2091 1.79086 98 4 98H188C190.209 98 192 96.2091 192 94V4C192 1.79086 190.209 0 188 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_98)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162 0L64 98H265.514V0",
    fill: "#ABB8DB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.818 16.2727H113.273C108.854 16.2727 105.273 19.8544 105.273 24.2727V81C105.273 85.4183 108.854 89 113.273 89H151.818C156.236 89 159.818 85.4183 159.818 81V24.2727C159.818 19.8544 156.236 16.2727 151.818 16.2727Z",
    fill: "#8394C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.864 65.5909L123.507 89H111.125C107.893 89 105.273 86.3798 105.273 83.1477V79.883L146.864 65.5909Z",
    fill: "#6E82B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 9H146C150.418 9 154 12.5817 154 17V60L133 81H106C101.582 81 98 77.4183 98 73V17C98 12.5817 101.582 9 106 9Z",
    fill: "#F0F3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 20.6171C103 17.3514 105.411 15 108.804 15H128C130.758 15 133 17.1674 133 19.8333V39.1667C133 41.8326 130.758 44 128 44H108C105.242 44 103 41.8326 103 39.1667V20.6171ZM146.68 17.7036C147.492 18.1266 148 18.9422 148 19.8333V39.1667C148 40.0578 147.492 40.8734 146.68 41.2964C145.867 41.7193 144.883 41.674 144.109 41.1755L136.609 36.3422L135.5 35.6247V34.3333V24.6667V23.3753L136.609 22.6578L144.109 17.8245C144.875 17.3336 145.859 17.2807 146.68 17.7036Z",
    fill: "#B3C0E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 64L117 81H133.174L134 64Z",
    fill: "#DDE2F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141 60H154L133 81V68C133 63.5817 136.582 60 141 60Z",
    fill: "#B8C4E6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188 0H4C1.79086 0 0 1.79086 0 4V94C0 96.2091 1.79086 98 4 98H188C190.209 98 192 96.2091 192 94V4C192 1.79086 190.209 0 188 0Z",
    fill: "url(#paint0_linear_1_98)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 20,
    width: 22,
    height: 6,
    rx: 1,
    fill: "#E9EDF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 34,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#E9EDF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 34,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#E9EDF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_98",
    x: 68,
    y: -21,
    width: 121.818,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.276 0 0 0 0 0.3624 0 0 0 0 0.6 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_98"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_98",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_98",
    x1: -3655.35,
    y1: 3072.25,
    x2: 15588,
    y2: 13104.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C4E6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520239,
    stopColor: "#7A8CBF",
    stopOpacity: 0.589731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E82B8",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailVideo);
export default __webpack_public_path__ + "static/media/thumbnail-video.d8244cf2a375a5ae6b7003f59fad179d.svg";
export { ForwardRef as ReactComponent };